<template>
    <page :title="title">
        You have successfully created your CRS account.
    </page>
</template>

<script>
import Page from './utilities/Page'
import { API } from '../api/axios'

export default {
  name: 'RegistrationCompleted',
  components: {Page},
  data () {
    return {
      success: null,
    }
  },
  mounted () {
    let token = this.$route.params.token
    let userId = this.$route.params.userId

    console.log('Registration token:', token)
    console.log('User id:', userId)

    API.post(`/users/emailvalidation?id=${userId}&code=${token}`)
      .then(response => {
        this.success = true
        console.log('Email validation successfull!', response)
      })
      .catch(error => {
        this.success = false
        console.error('Email validation failed!', error)
      })
  },
  computed: {
    title () {
      if (this.success === null) {
        return 'Validating registration'
      }
      return this.success ? 'Registration failed' : 'Registration completed'
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RegistrationCompleted.vue